import React from "react";
import toast from "react-hot-toast";

export const Copier = ({ text, children, notify = true }) => {
  const onClick = async () => {
    try {
      if (navigator.clipboard && window.isSecureContext) {
        // For modern browsers
        await navigator.clipboard.writeText(text);
      } else {
        // Fallback for older browsers
        const textArea = document.createElement('textarea');
        textArea.value = text;
        textArea.style.position = 'fixed';
        textArea.style.left = '-999999px';
        textArea.style.top = '-999999px';
        document.body.appendChild(textArea);
        textArea.focus();
        textArea.select();
        document.execCommand('copy');
        textArea.remove();
      }
      if (notify) {
        toast.success("Copied to clipboard", {
          duration: 2000,
          removeDelay: 0,
        });
      }
    } catch (error) {
      console.error("There was a problem copying text");
      console.error(error.message);
    }
  };

  return (
    <span onClick={onClick} style={{ cursor: "pointer" }}>
      {children}
    </span>
  );
};
